import { Backdrop } from "@mui/material";
import {
  getTenantCustomPlan,
  activateCustomOfflinePlan,
  getTenantPlanDetails,
  getCreditsList,
  getPaymentList,
} from "action/plans";
import { useState } from "react";
import { useDispatch } from "react-redux";
import {
  Button,
  FormGroup,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import Swal from "sweetalert2";

function ActivatePlanModal({
  showActivateModal,
  setShowActivateModal,
  customPlanDetails,
}) {
  const dispatch = useDispatch();
  const [activatePlanForm, setActivatePlanForm] = useState({
    transactionId: { value: "", errMsg: "" },
    remark: { value: "", errMsg: "" },
  });
  const [showLoaderOnActivate, setShowLoaderOnActivate] = useState(false);
  const handleOnChange = (name, value) => {
    setActivatePlanForm((prevState) => {
      return { ...prevState, [name]: { value, errMsg: "" } };
    });
  };

  const handleOnBlur = (name, value) => {
    let errMsg = "";
    const trimmedValue = value.trim();
    switch (name) {
      // case "transactionId":
      //   if(trimmedValue !== "" && trimmedValue.length < 5){
      //     errMsg="Please enter a Transaction ID greater than 5."
      //   }
      //   break;
      case "remark":
        if (trimmedValue.length === 0) {
          errMsg = "Please enter a remark.";
        }
      default:
        break;
    }

    setActivatePlanForm((prevState) => {
      return { ...prevState, [name]: { ...prevState[name], errMsg } };
    });
  };

  //on Activate click checking validation and if valid calling the api to activate plan
  const onClickActivate = async () => {
    if (activatePlanForm.remark.value.trim() === "") {
      setActivatePlanForm((prevState) => {
        return {
          ...prevState,
          remark: { ...prevState.remark, errMsg: "Please enter a remark." },
        };
      });
    } else {
      setShowLoaderOnActivate(true);
      const bodyData = {
        tenantID: customPlanDetails.tenantID,
        remark: activatePlanForm.remark.value,
        transactionID: activatePlanForm.transactionId.value,
      };
      const activatePlanRes = await activateCustomOfflinePlan(bodyData);
      if (activatePlanRes && activatePlanRes.code === 200) {
        Swal.fire({
          title: "Plan activated successfully.",
          icon: "success",
          showConfirmButton: false,
          timer: 3000,
        });
        // on success response calling othe apis to reflect the data
        getTenantCustomPlan(
          dispatch,
          `?tenantID=${customPlanDetails.tenantID}&status=["PENDING"]`
        );
        getTenantPlanDetails(dispatch, customPlanDetails.tenantID);
        getCreditsList(dispatch, customPlanDetails.tenantID, 1);
        const query = JSON.stringify([
          {
            field: "PaymentStatus",
            condition: "in",
            filterValues: ["captured"],
          },
        ]);
        getPaymentList(dispatch, customPlanDetails.tenantID, 1, query);
        setShowActivateModal(false);
      } else {
        Swal.fire({
          title: activatePlanRes?.data?.message
            ? activatePlanRes?.data?.message
            : "Something went wrong!",
          text: "Couldn't activate plan.",
          icon: "error",
          showConfirmButton: false,
          timer: 3000,
        });
      }
      setShowLoaderOnActivate(false);
    }
  };
  return (
    <>
      <Backdrop
        sx={styles.backBropStyle} // Ensures it's on top of other elements
        open={showLoaderOnActivate}
      >
        <i className="fa fa-spinner fa-spin fa-3x text-black" />
      </Backdrop>
      <Modal
        isOpen={showActivateModal}
        toggle={() => setShowActivateModal(!showActivateModal)}
        centered
        backdrop={"static"}
      >
        <ModalHeader toggle={() => setShowActivateModal(!showActivateModal)}>
          Activate Plan
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <label className="form-control-label">
              Remark for Offline Payment{" "}
              <strong style={{ color: "red" }}>*</strong>
            </label>
            <Input
              className={activatePlanForm.remark.errMsg ? "is-invalid" : ""}
              rows="3"
              type="textarea"
              name="remark"
              value={activatePlanForm.remark.value}
              maxLength={200}
              onChange={(e) => handleOnChange("remark", e.target.value)}
              onBlur={(e) => handleOnBlur(e.target.name, e.target.value)}
            />
            {activatePlanForm.remark.errMsg && (
              <small className="text-danger">
                {activatePlanForm.remark.errMsg}
              </small>
            )}
          </FormGroup>
          <FormGroup>
            <label className="form-control-label">
              Transaction ID {/* <strong style={{ color: "red" }}>*</strong> */}
            </label>
            <Input
              type="text"
              name="transactionId"
              className={
                activatePlanForm.transactionId.errMsg ? "is-invalid" : ""
              }
              value={activatePlanForm.transactionId.value}
              onChange={(e) => handleOnChange(e.target.name, e.target.value)}
              onBlur={(e) => handleOnBlur(e.target.name, e.target.value)}
              maxLength={100}
            />
            {activatePlanForm.transactionId.errMsg && (
              <small className="text-danger">
                {activatePlanForm.transactionId.errMsg}
              </small>
            )}
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button
            color="info"
            onClick={() => onClickActivate()}
            disabled={Object.values(activatePlanForm).some(
              (item) => item.errMsg !== ""
            )}
          >
            Activate
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ActivatePlanModal;

const styles = {
  backBropStyle: { color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 },
};
